import HashReturnObject from '../models/HashReturnObject';
import { getBaseAPI } from "../environments/Environments";
import { mapSessionData, SessionModel } from '../models/Session';
import AppointmentStatus from '../models/AppointmentStatus';
import AppointmentDetailsData from '../models/AppointmentDetails';
import { getDateTimeObj } from '../utils/Util';
import { apiFetch } from './ServiceHelper';
import ErrorService from "./ErrorService";


export default class ConfirmationService {
    static confirmAppointment = (session: SessionModel): Promise<HashReturnObject<AppointmentDetailsData>> => {
        //const state = useAppSelector(state => state)
        return new Promise( async (resolve, reject) => {
            const url = await getBaseAPI() + '/api/v1/Patient/saveAppointment';
            // const appointmentDetailsData = (val: unknown) => mapSessionData(session);
            // appointmentDetailsData.apptDateTime =  getDateTimeObj(session.ApptDateTime).dateTime;
            const payload = JSON.stringify(mapSessionData(session));
            apiFetch(url, {
                method: 'POST',
                body: payload,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then((result) => Promise.resolve(result))
                .then((hashReturnObject: any) => {
            
                    if (hashReturnObject.hasOwnProperty('error')) {
                        ErrorService.showErrorAlert('Oops! Something went wrong. Please try again later. If the issue persists, please contact our support team for assistance.', hashReturnObject);
                    }

                    const reservations: AppointmentDetailsData[] = [];
                    reservations.push(hashReturnObject.data);

                    const responseObject: HashReturnObject<AppointmentDetailsData> = {
                        data: reservations,
                        hash: hashReturnObject.hash,
                        sessionId: hashReturnObject.sessionId
                    }
                    resolve(responseObject);
                })
                .catch((e) => {
                    console.log('Confirmation Service error');
                    reject(e);
                });
        });
    }
    static reserveAppointment = (session: SessionModel): Promise<HashReturnObject<AppointmentStatus>> => {
        return new Promise( async (resolve, reject) => {
            const url = await getBaseAPI() + '/api/v1/Patient/updateAppointmentTime';
            const appointmentDetailsData = mapSessionData(session);         
            //appointmentDetailsData.apptDateTime =  getDateTimeObj(session.ApptDateTime).dateTime;
            const apptTime =  getDateTimeObj(session.ApptDateTime).dateTime;
            //const payload = JSON.stringify(appointmentDetailsData);
            apiFetch(url, {
                method: 'POST',
                body: JSON.stringify({
                    "apptDateTime": apptTime,
                    "logKey": session.LogKey,
                    "groupKey": session.GroupKey,
                    "coverKey" : session.CoverKey,
                    "locKey": session.LocKey,
                    "acctKey": session.AcctKey,
                    "addKey": session.AddKey,
                    "taskKey": session.TaskKey,
                    "apptKey": session.ApptKey,
                    "currentPage": 0
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then((result) => Promise.resolve(result))
                .then((hashReturnObject: any) => {               
                    if (hashReturnObject.hasOwnProperty('error')) {
                        ErrorService.showErrorAlert('Oops! Something went wrong. Please try again later. If the issue persists, please contact our support team for assistance.', hashReturnObject);
                    }
                    const reservations: AppointmentStatus[] = [];
                    reservations.push(hashReturnObject.data);

                    const responseObject: HashReturnObject<AppointmentStatus> = {
                        data: reservations,
                        hash: hashReturnObject.hash,
                        sessionId: hashReturnObject.sessionId
                    }
                    resolve(responseObject);
                })
                .catch((e) => {
                    console.log('Confirmation service error');
                    reject(e);
                });
        });
    }
    static cancelAppointment = (logKey: string | null | undefined, apptKey: any): Promise<HashReturnObject<AppointmentStatus>> => {
        // var arrayAppt = apptKey;
        //     var index = arrayAppt.indexOf(''); 
        //     delete arrayAppt[index];
        return new Promise( async (resolve, reject) => {
            const url = await getBaseAPI() + '/api/v1/Patient/preCancelAppointment';
            apiFetch(url, {
                method: 'POST',
                body: JSON.stringify({
                    "logKey": logKey,
                    "apptKeysToBeCancelled": apptKey
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then((result) => Promise.resolve(result))
                .then((hashReturnObject: any) => {
                    const reservations: AppointmentStatus[] = [];
                    reservations.push(hashReturnObject.data);

                    const responseObject: HashReturnObject<AppointmentStatus> = {
                        data: reservations,
                        hash: hashReturnObject.hash,
                        sessionId: hashReturnObject.sessionId
                    }
                    resolve(responseObject);
                })
                .catch((e) => {
                    console.log('Confirmation Service error');
                    reject(e);
                });
        });
    }
}